import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { Palette, BarChart3, Upload, FileText, MessageSquare, User, Settings, Bell, LogOut, Menu, X } from 'lucide-react';
import { supabase } from '../utils/supabaseClient';
import UnifiedDashboardLayout from './UnifiedDashboardLayout';
import '../styles/ArtistStudio.css';

const ArtistStudio = () => {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [userStats, setUserStats] = useState({
    artworkCount: 0,
    totalViews: 127,
    totalLikes: 89,
    submissionsCount: 0,
    pendingInquiries: 0
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Get current user from Supabase auth
  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        setUser(user);
        
        // If we have a user, also fetch their profile data and stats
        if (user) {
          const [profileResult, artworksResult, submissionsResult] = await Promise.all([
            supabase
              .from('users')
              .select('nickname, handle, preferences, profile_img')
              .eq('uuid', user.id)
              .single(),
            supabase
              .from('vcs')
              .select('vc_id')
              .eq('uuid', user.id)
              .eq('access_control', 'Public'),
            supabase
              .from('artist_submission_mapping')
              .select('submission_id')
              .eq('user_id', user.id)
          ]);
          
          if (profileResult.data) {
            setUserStats(prev => ({
              ...prev,
              nickname: profileResult.data.nickname,
              handle: profileResult.data.handle,
              preferences: profileResult.data.preferences
            }));
          }
          
          setUserStats(prev => ({
            ...prev,
            artworkCount: artworksResult.data?.length || 0,
            submissionsCount: submissionsResult.data?.length || 0
          }));
        }
      } catch (error) {
        console.error('Error getting current user:', error);
      } finally {
        setLoading(false);
      }
    };
    
    getCurrentUser();
  }, []);

  const navItems = [
    { name: 'Dashboard', href: '/artist/dashboard', icon: BarChart3 },
    { name: 'Artworks', href: '/artist/artworks', icon: Palette },
    { name: 'Upload', href: '/artist/upload', icon: Upload },
    { name: 'Submissions', href: '/artist/submissions', icon: FileText },
    { name: 'Inquiries', href: '/artist/inquiries', icon: MessageSquare },
    { name: 'Profile', href: '/artist/profile', icon: User },
  ];



  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading Artist Studio...</p>
      </div>
    );
  }

  return (
    <UnifiedDashboardLayout
      dashboardType="artist"
      navItems={navItems}
      logoText="Artist Studio"
      logoIcon={Palette}
      context={{ user, userStats, setUserStats }}
    >
      <Outlet context={{ user, userStats, setUserStats }} />
    </UnifiedDashboardLayout>
  );
};

export default ArtistStudio; 